import AbstractApiService from "./AbstractApiService";

export default class UserService extends AbstractApiService {
    login = (email: string, password: string): Promise<any> => {
        return this.call('POST', '/login', JSON.stringify({
            email,
            password,
        }));
    };

    signup = (email: string, password: string, captcha: string|null): Promise<any> => {
        return this.call('POST', '/signup', JSON.stringify({
            email,
            password,
            captcha,
        }));
    };

    forgotPassword = (email: string): Promise<any> => {
        return this.call('POST', '/password/forgot', JSON.stringify({
            email,
        }));
    };

    resetPassword = (token: string|null, email: string|null, newPassword: string): Promise<any> => {
        return this.call('POST', '/password/reset', JSON.stringify({
            token,
            email,
            password: newPassword,
        }));
    };

    logout = (): Promise<any> => {
        return this.call('GET', '/me/logout');
    };

    me = (): Promise<any> => {
        return this.call('GET', '/me');
    };

    useSubscriptionCode = (code: string): Promise<any> => {
        return this.call('POST', '/me/subscription-code', JSON.stringify({
            code,
        }));
    };

    update = (data: {[key: string]: any}): Promise<any> => {
        return this.call('PUT', '/me', JSON.stringify(data));
    };

    createCredential = (api: string, clientId: string, clientSecret: string): Promise<any> => {
        return this.call('POST', `/me/credential/${api}`, JSON.stringify({
            client_id: clientId,
            client_secret: clientSecret,
        }));
    };

    deleteCredential = (api: string): Promise<any> => {
        return this.call('DELETE', `/me/credential/${api}`);
    };
}